import { ISvgProps } from '@src/types';

const Stickers = ({ width = '22px', height = '22px', fillColor = 'var(--font-color)', ...props }: ISvgProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group" fill={fillColor} fillRule="nonzero">
          <path
            d="M15.7142105,14.9285 L21.269184,14.9285 C21.028892,15.3487914 20.732879,15.7346656 20.3891882,16.0756373 L16.0756374,20.3891881 C15.7346656,20.7328789 15.3487915,21.028892 14.9285,21.2691839 L14.9285,15.7142105 C14.9285,15.2802745 15.2802746,14.9285 15.7142105,14.9285 L15.7142105,14.9285 Z"
            id="Path"
          ></path>
          <path
            d="M19.6427632,0 C20.9429592,0.00388313986 21.9960116,1.0569356 21.999949,2.35713157 L21.999949,12.1863702 C22.001677,12.5800683 21.9595114,12.9727353 21.8741811,13.3570789 L15.7142105,13.3570789 C14.4140146,13.3609621 13.3609621,14.4140145 13.357079,15.7142105 L13.357079,21.874181 C12.9727353,21.9595113 12.5800683,22.0016769 12.1863703,21.9999489 L2.35713158,21.9999489 C1.0569356,21.9960115 0.00388313988,20.9429591 0,19.6427631 L0,2.35713157 C0.00388313988,1.0569356 1.0569356,0.00388313986 2.35713158,0 L19.6427632,0 Z M6.91747627,5.31291329 C5.48815019,5.31291329 4.32945246,6.46156499 4.32945246,7.87849867 C4.32945246,9.29543236 5.48815019,10.4440841 6.91747627,10.4440841 C8.34680236,10.4440841 9.50550009,9.29543236 9.50550009,7.87849867 C9.50550009,6.46156499 8.34680236,5.31291329 6.91747627,5.31291329 Z M15.0824727,5.31291329 C13.6531466,5.31291329 12.4944489,6.46156499 12.4944489,7.87849867 C12.4944489,9.29543236 13.6531466,10.4440841 15.0824727,10.4440841 C16.5117988,10.4440841 17.6704965,9.29543236 17.6704965,7.87849867 C17.6704965,6.46156499 16.5117988,5.31291329 15.0824727,5.31291329 Z"
            id="Combined-Shape"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default Stickers;
